import { definitions } from '@luxuryescapes/contract-business'

export type ProfilePutResult = definitions['mePutProfile']

export function mapProfileResponseToUserDetails(result: ProfilePutResult | null | undefined): Partial<App.AuthAccount> {
  if (!result) return { email: '', givenName: undefined, surname: undefined }
  return {
    givenName: result.givenName ?? undefined,
    surname: result.surname ?? undefined,
    title: (result.title as App.Title) ?? undefined,
    email: result.email ?? '',
    dob: result.dob ?? undefined,
    postcode: result.postcode ?? undefined,
    phonePrefix: result.phone_prefix ?? undefined,
    phone: result.phone ?? undefined,
    countryCode: result.country_code ?? undefined,
  }
}
